const Enums = {

  LookupType: {
    Country: 1,
    SystemLocale: 2,
    Timezone: 3,
    Currency: 4,
    DateFormat: 5,
  },

  ChangeStatus: {
    Update: 0,
    Activate: 1,
    DeActivate: 2,
    Delete: 3,
    OutOfStock: 4,
    InStock: 5,
    Block: 6,
    UnBlock: 7,
    SetDefault: 8,
    SortOrder: 9,
    DelinkDevice: 10,
    LinkDevice: 11,
    RemoveDefault: 12,
    POSOutOfStock: 13,
    POSInStock: 14,
    EnableAutoUpdate : 15,
    DisableAutoUpdate : 16
  },

  GroupMappingTables: [
    { value: "AddOnMaster", label: "AddOnMaster" },
    { value: "Advertisement", label: "Advertisement" },
    { value: "AllergenMaster", label: "AllergenMaster" },
    { value: "CategoryMaster", label: "CategoryMaster" },
    { value: "ConditionalVoucher", label: "ConditionalVoucher" },
    { value: "CurrencyDelimiter", label: "CurrencyDelimiter" },
    { value: "Discount", label: "Discount" },
    { value: "KitchenComment", label: "KitchenComment" },
    { value: "KitchenCommentCategory", label: "KitchenCommentCategory" },
    { value: "KitchenDisplay", label: "KitchenDisplay" },
    { value: "LoyaltyPointSettings", label: "LoyaltyPointSettings" },
    { value: "MealTypeMaster", label: "MealTypeMaster" },
    { value: "MenuType", label: "MenuType" },
    { value: "OptionSetMaster", label: "OptionSetMaster" },
    { value: "OrderMaster", label: "OrderMaster" },
    { value: "PayInOut", label: "PayInOut" },
    { value: "POSCashInOut", label: "POSCashInOut" },
    { value: "POSConfiguration", label: "POSConfiguration" },
    { value: "POSPaymentSetting", label: "POSPaymentSetting" },
    { value: "POSUser", label: "POSUser" },
    { value: "PrinterSettings", label: "PrinterSettings" },
    { value: "ProductMaster", label: "ProductMaster" },
    { value: "Promotion", label: "Promotion" },
    { value: "ReceiptPrinter", label: "ReceiptPrinter" },
    { value: "ReportDepartment", label: "ReportDepartment" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "RestaurantArea", label: "RestaurantArea" },
    { value: "RestaurantDevice", label: "RestaurantDevice" },
    { value: "RestaurantPrintLayout", label: "RestaurantPrintLayout" },
    { value: "RestaurantService", label: "RestaurantService" },
    { value: "RestaurantTable", label: "RestaurantTable" },
    { value: "RestaurantTableGeneralSetting", label: "RestaurantTableGeneralSetting" },
    { value: "ScheduleDayMaster", label: "ScheduleDayMaster" },
    { value: "ServiceZone", label: "ServiceZone" },
    { value: "Staff", label: "Staff" },
    { value: "StaffLog", label: "StaffLog" },
    { value: "TableReservations", label: "TableReservations" },
    { value: "TagMaster", label: "TagMaster" },
    { value: "TaxMaster", label: "TaxMaster" },
    { value: "User", label: "User" },
    { value: "UserGroup", label: "UserGroup" },
    { value: "UserReports", label: "UserReports" },
    { value: "VariantCategoryMaster", label: "VariantCategoryMaster" },
    { value: "VariantMaster", label: "VariantMaster" }
  ],

};


export { Enums };
